<ng-container *transloco="let convert;">
  @if (isVisible) {
    @if (removalHistory && removalHistory.length > 0) {
      <div class="removal-history">
        <div class="removal-history__content">
          <!-- Header -->
          <div role="alert">
            <header>
              <h3 class="fw-normal history-heading" tabindex="-1">{{convert('sellModule.manageInventory.removalHistory.textHistory')}}</h3>
            </header>
          </div>
          <!-- History Entries -->
          @for (entry of removalHistory; track entry; let i = $index) {
            <div class="removal-date__date">
              <span class="removal-date__date-text">{{
                  localizeDate(entry.statusChangedDate)
                }}</span>
            </div>
            <div [ngClass]="i%2 == 0 ? 'history-entry' : 'history-entry__grey'">
              <div class="removal-time"
                   [attr.aria-label]="'Removed Time for  ' + (localizeDate(entry.statusChangedDate))"
              >
                {{formatTime(entry)}}
              </div>
              <div class="history-details">
                <div class="history-col">
                  <dl>
                    <div class="text-truncate">
                      <dt class="field-label">{{convert('sellModule.manageInventory.removalHistory.textRemovalReason')}}</dt>
                      <dd
                        class="text-truncate"
                        [attr.aria-label]="convert('sellModule.manageInventory.removalHistory.ariaLabelRemovalReason') + (localizeDate(entry.statusChangedDate))"
                      >
                        {{entry.removalReason || 'N/A'}}
                      </dd>
                    </div>
                    <div>
                      <dt class="field-label" >{{convert('sellModule.manageInventory.removalHistory.textPostedDate')}}</dt>
                      <dd [attr.aria-label]="convert('sellModule.manageInventory.removalHistory.ariaLabelPostedDate') + (localizeDate(entry.statusChangedDate))">
                        {{formatDateTime(entry)}}
                      </dd>
                    </div>
                    <div>
                      <dt class="field-label">{{convert('sellModule.manageInventory.removalHistory.textHits')}}</dt>
                      <dd [attr.aria-label]="convert('sellModule.manageInventory.removalHistory.ariaLabelHits') + (localizeDate(entry.statusChangedDate))">
                        {{entry.viewCount}}
                      </dd>
                    </div>
                    <div>
                      <dt class="field-label">{{convert('sellModule.manageInventory.removalHistory.textBidListAdds')}}</dt>
                      <dd [attr.aria-label]="convert('sellModule.manageInventory.removalHistory.ariaLabelBidListAdds') + (localizeDate(entry.statusChangedDate))">
                        {{entry.bidListAdds}}
                      </dd>
                    </div>
                  </dl>
                </div>
                <div class="history-col left-padding">
                  <dl>
                    <div>
                      <dt class="field-label">{{convert('sellModule.manageInventory.removalHistory.textPostingPrice')}}</dt>
                      <dd [attr.aria-label]="convert('sellModule.manageInventory.removalHistory.ariaLabelPostingPrice') + localizeDate((entry.statusChangedDate))">
                        {{formatCurrency(entry.currentAmount)}}
                      </dd>
                    </div>
                    <div>
                      <dt class="field-label">{{convert('sellModule.manageInventory.removalHistory.textBuyNowPrice')}}</dt>
                      <dd [attr.aria-label]="convert('sellModule.manageInventory.removalHistory.ariaLabelBuyNowPrice') + localizeDate((entry.statusChangedDate))">
                        {{entry.buyNowAmount ? formatCurrency(entry.buyNowAmount) : 'N/A'}}
                      </dd>
                    </div>
                    <div>
                      <dt class="field-label">{{convert('sellModule.manageInventory.removalHistory.textFees')}}</dt>
                      <dd [attr.aria-label]="convert('sellModule.manageInventory.removalHistory.ariaLabelFees') + localizeDate((entry.statusChangedDate))">
                        {{entry.saleFee != null ? formatCurrency(entry.saleFee) : 'N/A'}}
                      </dd>
                    </div>
                    <div>
                      <dt class="field-label">{{convert('sellModule.manageInventory.removalHistory.textHighestOfferPrice')}}</dt>
                      <dd [attr.aria-label]="convert('sellModule.manageInventory.removalHistory.ariaLabelHighestOfferPrice') + localizeDate((entry.statusChangedDate))">
                        {{entry.highestOffer ? formatCurrency(entry.highestOffer) : 'N/A'}}
                      </dd>
                    </div>
                  </dl>
                  <button
                    class="btn btn-link see-details-btn"
                    [attr.aria-label]="convert('sellModule.manageInventory.removalHistory.ariaLabelSeePostingDetail') +
              localizeDate((entry.statusChangedDate))"
                    (click)="seeDetails(i)"
                    #heading
                  >
                    <strong>{{convert('sellModule.manageInventory.removalHistory.textSeeDetails')}}</strong>
                  </button>
                </div>
              </div>
            </div>
          }
        </div>
        <div class="history__close">
          <button
            class="history__close__button"
            [attr.aria-label]="convert('common.ariaLabelCloseHistory')"
            data-track-elem="icon"
            data-track-name="Close"
            data-track-trigger="close"
            (click)="closeHistory()"
          >
            <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    }
  }
</ng-container>

